import React from "react";
import { motion } from "framer-motion";

const Cta = ({heading, desc, slug}) => {
  return (
    <>
      <section className="cta-section">

        {/* OVERLAY */}
        <motion.div
          className="cta-overlay"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        ></motion.div>

        {/* CONTENT */}
        <motion.div
          className="cta-content container"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            duration: 0.9,
            ease: [0.22, 1, 0.36, 1],
          }}
          viewport={{ once: true, amount: 0.3 }}
        >

          {/* HEADING */}
          <motion.h2
            className="section-heading"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.15,
              duration: 0.7,
            }}
            viewport={{ once: true }}
          >
            { heading || "Precision Packaging for Every Industrial Application."}
          </motion.h2>

          {/* TEXT */}
          <motion.p
            className="section-text"
            initial={{ opacity: 0, y: 25 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{
              delay: 0.3,
              duration: 0.7,
            }}
            viewport={{ once: true }}
          >
            { desc || "We are here to provide the best packaging solutions tailored to your needs." }
          </motion.p>

          {/* BUTTON */}
          <motion.a
            href={ slug || "/products/customised-packaging" }
            className="hero-btn"
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{
              delay: 0.45,
              duration: 0.5,
            }}
            viewport={{ once: true }}
            whileHover={{
              scale: 1.05,
              y: -2,
            }}
            whileTap={{ scale: 0.97 }}
          >
            Get a Quote
          </motion.a>

        </motion.div>

      </section>
    </>
  );
};

export default Cta;